<section class="mealset" [class.unpublished]="!published">
  <picture *ngIf="image">
    <source srcset="{{image.webp}}" type="image/webp">
    <img src="{{image.jpg}}" alt="{{title}} Image" type="image/jpg"/>
  </picture>
  <header>
    <h1>{{title}}</h1>
    <p>{{tagline}}</p>
  </header>
  <div attr.id="mealset-{{id}}" class="mealset-content" [attr.aria-hidden]="!open" *ngIf="open">
    <ng-container *ngIf="mealSet$|async as mealSet; else loading">
      <div class="mealset-description" *ngIf="mealSet.description">
        <p>{{mealSet.description}}</p>
      </div>
      <app-mealset-section *ngIf="mealSet.mealSetIncludes && mealSet.mealSetIncludes.length > 0" class="includes" title="includes">
        <ul class="includes" aria-label="Included items">
          <li *ngFor="let include of mealSet.mealSetIncludes">
            <h3>{{include.menuItem.name}}</h3>
            <p *ngIf="include.menuItem.description">{{include.menuItem.description}}</p>
            <ul class="allergies" *ngIf="include.menuItem.dietaryPreferences" aria-label="allergies">
              <li *ngFor="let a of include.menuItem.dietaryPreferences">
                <span 
                  matTooltip="{{a.name}}{{a.description ? ':' + a.description : ''}}"
                >
                  <img src="{{a.image.jpg}}" alt="{{a.name}}" title="{{a.name}}">
              </span>
                
              </li>
            </ul>
          </li>
        </ul>
      </app-mealset-section>
      


      <app-mealset-section price *ngIf="mealSet.mealSetGroups[0].price || mealSet.mealSetGroups[0].variants.length" [title]="(mealSet.mealSetGroups[0].optionTitle) ? mealSet.mealSetGroups[0].optionTitle : 'Price'" [rule]="mealSet.mealSetGroups[0].optionRule" class="price">
        <div class="section-price" *ngIf="mealSet.mealSetGroups[0].price">{{mealSet.mealSetGroups[0].price|cleanPrice}}</div>
        <ng-container *ngIf="mealSet.mealSetGroups[0].variants.length">
          <app-mealset-variable-price [prices]="mealSet.mealSetGroups[0].variants" class="mealset-option"></app-mealset-variable-price>
        </ng-container>
      </app-mealset-section>


      <ng-container *ngIf="mealSet.mealSetGroups">
        <ng-container *ngFor="let x of mealSet.mealSetGroups">
          <app-mealset-section *ngFor="let s of x.mealSetSection"
            [title]="s.name"
            [rule]="s.rule">
              <app-mealset-options 
                [menuItems]="s.sectionItems" 
                [costExtra]="(x.type === 'a-la-carte') ? false : true"
                class="mealset-option">
              </app-mealset-options>
          </app-mealset-section>
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-template #loading>
      <mat-spinner></mat-spinner>
    </ng-template>
  </div>
  <footer>
    <button [attr.aria-expanded]="open" attr.aria-controls="mealset-{{id}}" aria-label="View Mealset" title="View Mealset" (click)="expand()">
      <mat-icon *ngIf="!open">add_circle_outline</mat-icon>
      <mat-icon *ngIf="open">remove_circle_outline</mat-icon>
    </button>
  </footer>
</section>
